// Loads Google Identity Services' script once and caches the in-flight
// promise, so multiple components mounting a Google sign-in button
// (login page, signup page, ...) don't each inject a duplicate script.

let loadPromise: Promise<void> | null = null

export function loadGoogleIdentityScript(): Promise<void> {
  if (loadPromise) return loadPromise
  loadPromise = new Promise((resolve, reject) => {
    if (document.getElementById('google-identity-script')) {
      resolve()
      return
    }
    const script = document.createElement('script')
    script.id = 'google-identity-script'
    script.src = 'https://accounts.google.com/gsi/client'
    script.async = true
    script.defer = true
    script.onload = () => resolve()
    script.onerror = () => reject(new Error('Failed to load Google Identity Services'))
    document.head.appendChild(script)
  })
  return loadPromise
}

// Web OAuth 2.0 client ID from Google Cloud Console — same project
// (bacsys-cmms) and the same "Web" client the backend's
// GOOGLE_OAUTH_CLIENT_IDS verifies against and the mobile apps pass as
// their `serverClientId`. Client IDs aren't secret.
export const GOOGLE_CLIENT_ID = '724595434139-k94v76qd8shugck65m0pecj7ec5fcjj0.apps.googleusercontent.com'

declare global {
  interface Window {
    google?: {
      accounts: {
        id: {
          initialize: (config: {
            client_id: string
            callback: (response: { credential: string }) => void
          }) => void
          renderButton: (parent: HTMLElement, options: Record<string, unknown>) => void
        }
      }
    }
  }
}
